// Error tracking utility - ready for Sentry integration
interface ErrorContext {
  userId?: string;
  route?: string;
  action?: string;
  metadata?: Record<string, any>;
}

class ErrorTracker {
  private isInitialized = false;
  private userId?: string;

  init(config?: { dsn?: string }) {
    // Placeholder for Sentry or other error tracking service
    // To use Sentry: npm install @sentry/react
    // Then initialize here with: Sentry.init({ dsn: config?.dsn })
    this.isInitialized = true;
    console.log('Error tracking initialized');
  }

  setUser(userId: string, userInfo?: { email?: string; name?: string }) {
    this.userId = userId;
    // If using Sentry: Sentry.setUser({ id: userId, ...userInfo })
  }

  captureError(error: Error, context?: ErrorContext) {
    if (!this.isInitialized) {
      console.error('Error tracking not initialized', error);
      return;
    }

    // Log to console in development
    console.error('Captured error:', {
      message: error.message,
      stack: error.stack,
      userId: context?.userId || this.userId,
      ...context,
    });

    // If using Sentry: Sentry.captureException(error, { contexts: context })
  }

  captureMessage(message: string, level: 'info' | 'warning' | 'error' = 'info') {
    if (!this.isInitialized) return;
    
    console.log(`[${level.toUpperCase()}]`, message);
    // If using Sentry: Sentry.captureMessage(message, level)
  }
}

export const errorTracker = new ErrorTracker();
